<template>
  <v-window>
    <v-toolbar color="primary"
               app
               dense
               clipped-left>
      <template v-if="shouldShowNavigationDrawer">
        <v-toolbar-side-icon color="white--text"
                             @click.stop="showNavigationDrawer"></v-toolbar-side-icon>
      </template>
      <template v-else>
        <v-btn color="primary"
               icon
               @click="goBack">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </template>

      <v-toolbar-title class="white--text">{{ activeSection }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <template v-if="shouldShowNavigationDrawer">
        <v-btn :to="{path:$t('urlBuy')}"
               v-if="showBuyButton"
               round
               color="white"
               class="accent font-weight-bold initialize"
               :loading="isLoadingBalance">
          {{user.balance.totalWithCurrency}}
        </v-btn>

        <v-btn :to="{path: registeredWithBle ? $t('urlValidationWait') : $t('urlTeletac')}"
               v-if="showFinishRegisterButton"
               class="white--text font-weight-bold accent initialize"
               round>
          {{ $t('privateLayout.finishRegister') }}
        </v-btn>

      </template>
    </v-toolbar>

    <template v-if="shouldShowNavigationDrawer">
      <v-navigation-drawer fixed
                           :clipped="true"
                           app
                           v-model="drawer"
                           :class="{'bigScreen': $vuetify.breakpoint.lgAndUp, 'smallScreen': $vuetify.breakpoint.mdAndDown}"
                           width="240">

        <v-layout row
                  wrap
                  class="grey lighten-5"
                  style="height:130px">
          <v-flex>
            <v-layout pa-2
                      column
                      fill-height
                      class="grey--text text--darken-1">
              <img src="/image/private/logo.png"
                   width="85%"
                   class="mt-1"
                   style="margin-left:15px" />
              <v-spacer></v-spacer>
              <v-flex shrink
                      class="ml-3">
                <div class="subheading">{{user.name}}</div>
                <div class="caption">{{user.username}}</div>
                <div class="caption">{{user.prefix}} {{user.phone}}</div>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>

        <div id="leftDrawerOptions">
          <v-list dense
                  class="pa-0">
            <template v-for="item in items">
              <v-list-tile :to="{path: item.pathName}"
                           :key="item.text"
                           v-if="item.i18nText"
                           class="mr-0"
                           active-class="white--text secondary font-weight-bold pr-0 selected">

                <v-list-tile-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content class="optionSelected">
                  <v-list-tile-title>
                    {{ $t(item.i18nText) }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </div>

        <v-footer app
                  class="pa-0 grey lighten-3">
          <v-btn class="initialize ma-0"
                 color="grey"
                 @click="doLogout"
                 block
                 flat>{{ $t('global.button.logout') }}</v-btn>
          <v-divider vertical></v-divider>
        </v-footer>
      </v-navigation-drawer>
    </template>

    <v-content class="pb-0">
      <router-view></router-view>
      <wsp-footer></wsp-footer>
    </v-content>

  </v-window>
</template>

<script>
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import WspFooter from '@/components/commons/WspFooter';
import authService from '@/services/authService';
import userService from '@/services/userService';
import productService from '@/services/productService';
import sessionService from '@/services/sessionService';
import store from '@/store';
import _ from 'lodash';
import { setTimeout } from 'timers';

export default {
  name: 'PrivateLayout',
  components: {
    [WspFooter.name]: WspFooter
  },
  computed: {
    shouldShowNavigationDrawer() {
      return this.$route.name !== 'ParkingDetail' && this.$route.name !== 'Prescriptors';
    },
    notFinishedRegister() {
      return userService.noActivated() || userService.sentLetter();
    },
    showFinishRegisterButton() {
      return this.notFinishedRegister && this.$route.name !== 'TeletagList';
    },
    showWaitRegisterButton() {
      return this.notFinishedRegister && this.$route.name !== 'TeletagList' && userService.registeredWithBle();
    },
    showBuyButton() {
      return !this.notFinishedRegister && this.$vuetify.breakpoint.smAndUp && this.canBuy;
    },
    user() {
      return store.state.user;
    },
    activeSection() {
      if (this.$route.name === 'ParkingDetail') {
        return store.state.activeSection;
      }
      return this.$i18n.t(store.state.activeSection);
    },
    canBuy() {
      return productService.canBuyPack();
    },
    registeredWithBle() {
     return userService.registeredWithBle();
    }
  },
  data() {
    return {
      drawer: null,
      items: [],
      backToRouteObj: null,
      isLoadingBalance: false,
      balanceTimeUpdate: 0
    };
  },
  created() {
    this.loadDrawerOptions();
    EventBus.$on(keys.eventOnLanguageChanged, this.changeLanguage);
    EventBus.$on(keys.eventShowDrawer, this.hideDrawer);
    EventBus.$on(keys.goToUrl, this.onGoToUrl);
    EventBus.$on(keys.polBalance, this.polBalance);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.changeLanguage);
    EventBus.$off(keys.eventShowDrawer, this.hideDrawer);
    EventBus.$off(keys.goToUrl, this.onGoToUrl);
    EventBus.$off(keys.polBalance, this.polBalance);
  },
  methods: {
    polBalance() {
      const self = this;
      this.isLoadingBalance = true;
      setTimeout(async () => {
        const balanceTotal = store.state.balanceBeforeBuying;
        await sessionService.check(false);
        const newBalanceTotal = store.state.user.balance.total;
        self.balanceTimeUpate++;
        if (self.balanceTimeUpdate < 6) {
          if (balanceTotal === newBalanceTotal) {
            EventBus.$emit(keys.polBalance, {});
          } else {
            self.stopPollingBalance();
          }
        } else {
          self.stopPollingBalance();
        }
      }, 5000);
    },
    stopPollingBalance() {
      this.balanceTimeUpate = 0;
      this.isLoadingBalance = false;
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: 'global.buy.success',
        type: 'success',
        doNotTranslate: false,
        timeout: 10000,
        isHtml: true
      });
      store.commit('UPDATE_BALANCE_BEFORE_BUYING', { balanceBeforeBuying: store.state.user.balance.total });
    },
    onGoToUrl(params) {
      this.backToRouteObj = params.routeObj;
    },
    goBack() {
      if (this.backToRouteObj !== null) {
        this.$router.push(this.backToRouteObj);
      } else {
        if (this.$route.name === 'ParkingDetail') {
          store.commit('SET_RESTORE_HOME_DATA', { data: true });
        }

        if (store.state.lastRoute !== null) {
          let path = store.state.lastRoute.fullPath;
          this.$router.push({ path: path });
        } else {
          this.$router.push({ name: 'UserHome' });
        }
      }
      this.backToRouteObj = null;
    },
    doLogout(command) {
      authService.logout();
    },

    showNavigationDrawer() {
      this.drawer = !this.drawer;
    },

    changeLanguage: function(params) {
      this.$router.replace(this.$i18n.t(this.$route.meta.i18nUrlLabel, this.$route.params));

      _.each(this.items, it => {
        it.pathName = this.$i18n.t(it.i18nUrl);
      });
    },

    hideDrawer() {
      this.drawer = false;
    },

    loadDrawerOptions() {
      this.items = [
        {
          icon: 'local_parking',
          i18nText: 'menu.option.parkings',
          i18nUrl: 'urlUser',
          pathName: this.$i18n.t('urlUser')
        },
        {
          icon: 'bookmark',
          i18nText: 'menu.option.reservations',
          i18nUrl: 'urlMyReservations',
          pathName: this.$i18n.t('urlMyReservations')
        },
        {
          icon: 'account_circle',
          i18nText: 'menu.option.profile',
          i18nUrl: 'urlProfile',
          pathName: this.$i18n.t('urlProfile')
        }
      ];
      if (!userService.registeredWithBle()) {
        this.items = this.items.concat([
          {
            icon: 'card_membership',
            i18nText: 'menu.option.tags',
            i18nUrl: 'urlTeletac',
            pathName: this.$i18n.t('urlTeletac')
          }
        ]);
      }

      if (this.activeTagsSection) {
        this.items = this.items.concat([
          {
            icon: 'card_membership',
            i18nText: 'menu.option.tags',
            i18nUrl: 'urlTeletac',
            pathName: this.$i18n.t('urlTeletac')
          }
        ]);
      }

      if (productService.canBuyPack()) {
        this.items = this.items.concat([
          {
            icon: 'account_balance_wallet',
            i18nText: 'menu.option.balance',
            i18nUrl: 'urlBuy',
            pathName: this.$i18n.t('urlBuy')
          }
        ]);
      }

      this.items = this.items.concat([
        {
          icon: 'card_giftcard',
          i18nText: 'menu.option.promos',
          i18nUrl: 'urlPromos',
          pathName: this.$i18n.t('urlPromos')
        },
        {
          icon: 'local_atm',
          i18nText: 'menu.option.funds',
          i18nUrl: 'urlFunds',
          pathName: this.$i18n.t('urlFunds')
        },
        {
          icon: 'business',
          i18nText: 'menu.option.business',
          i18nUrl: 'urlBusiness',
          pathName: this.$i18n.t('urlBusiness')
        },
        {
          icon: 'location_city',
          i18nText: 'menu.option.tenant',
          i18nUrl: 'urlTenant',
          pathName: this.$i18n.t('urlTenant')
        },
        {
          icon: 'contact_support',
          i18nText: 'menu.option.faq',
          i18nUrl: 'urlFaq',
          pathName: this.$i18n.t('urlFaq')
        }
      ]);
    }
  }
};
</script>

<style lang="scss">
@import '~@/assets/css/private.scss';
</style>

<style lang="scss" scoped>
#leftDrawerOptions {
  overflow: auto;
  height: calc(100% - 183px);
}
.bigScreen {
  max-height: calc(100vh - 50px) !important;
}
.smallScreen {
  max-height: 100vh !important;
}
</style>


<style lang="scss">
.selected .optionSelected {
  background-image: url(/image/menu-selected-bordered.svg) !important;
  background-position-x: right !important;
  background-repeat: no-repeat !important;
  background-origin: border-box !important;
  background-clip: border-box !important;
  z-index: 9;
}
.v-navigation-drawer--is-mobile .selected .optionSelected {
  background-image: url(/image/menu-selected.svg) !important;
}
.v-list__tile__action {
  min-width: 40px !important;
}
</style>

